/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable */

/* eslint-disable */

import { Icon, makeStyles, RACButton, RACCard } from '@rentacenter/racstrap';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { useGlobalContext } from '../../context/global/GlobalContext';
import {
  PurchaseOrder,
  ReceivePO,
  ReceivePODetail,
  UpdatedPOInformation,
  ReceivePORequest,
  ReceivePOResponse,
  StoreActionItemRequest,
  ManageStoreActionItemsResponse,
} from '../../types/types';
import { generateFlatReceivedDetails } from './RegularPOList';
import {
  PO_RECEIVED_ERROR,
  PO_RECEIVED_ERROR_TRY_AGAIN,
  PO_RECEIVED_SUCCESS,
  PO_REVERSE_ERROR,
  PO_REVERSED_SUCCESS,
  REDIRECT_ORIGIN,
  ReceiveNowType,
  SPO_AGREEMENT_CANCELLED,
} from '../../constants/constants';
import {
  receivePurchaseOrder,
  updateStoreActionItem,
} from '../../api/purchaseOrders';
import { AlertModal } from '../../common/AlertModal/AlertModal';
import { ReverseConfirm } from './ReverseConfirm';
import { TryAgainReceivePOModal } from './TryAgainReceivePOModal';
import { formatDate, getSelectedStore } from '../../utils/utils';
import {
  useSearchActions,
  useSearchDetails,
} from '../../context/Search/SearchProvider';
import { AppRoute } from '../../config/route-config';
import { LoadingOverlay } from '../../common/LoadingOverlay/LoadingOverlay';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { useStoreDetails } from '../../context/Store/StoreProvider';
import { debug } from 'console';

export interface ReceivingPOFooter {
  isPrintDisabled: boolean;
  onPrint: () => void;
}
const useStyles = makeStyles((theme: any) => ({
  footerRoot: {
    width: '100%',
    marginBottom: '0rem',
    display: 'block',
    position: 'fixed',
    bottom: '0',
    left: '0',
    zIndex: 1299,
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.typography.pxToRem(0),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0',
  },
  cardBody: {
    flex: '0 0 auto',
    padding: '1rem 1rem',
  },
  leftButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.typography.pxToRem(4),
  },
  rightButtonsContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    gap: theme.typography.pxToRem(4),
  },
  button: {
    height: theme.typography.pxToRem(43),
  },
  hideOnPrint: {
    '@media print': {
      display: 'none',
    },
  },
}));


export const buildReceivePORequest = (
  po: PurchaseOrder,
  updatesOnPO: UpdatedPOInformation[],
  bol: string,
  enableMXPOReceivingValue : string | undefined,
  editedItemCosts?: { [key: string]: string }
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {

  let poType = '';
  let receivedDetails = [];
  const dateReceived = formatDate(new Date(), 'yyyy-MM-dd');
  if (updatesOnPO.length) {
    receivedDetails = updatesOnPO.map((item) => {
      console.log(item.manufacturerSerialNumber, item, "items")
      console.log(item.manufacturerSerialNumber, item, "items")
      if (item.poType === 'ER' && !poType) poType = 'ER';
      const editedCostEntry = editedItemCosts
        ? Object.entries(editedItemCosts).find(([key]) =>
            key.includes(`-${item.purchaseOrderDetailId}-`)
          )
        : undefined;
      return {
        purchaseOrderDetailId: item.purchaseOrderDetailId || '',
        purchaseOrderDetailReceivedId: item.purchaseOrderDetailReceivedId || '',
        condition: 'NEW',
        partial: item.action === ReceiveNowType.Partial ? 'true' : 'false',
        partialReceiveReason: item.reason || '',
        dateReceived,
        billOfLading: enableMXPOReceivingValue == "1" ? bol : item.billOfLading || '' ,
        manufacturerSerialNumber: item.manufacturerSerialNumber || '',
        comments: item.comment || '',
        purchaseOrderVehicleDetailId: item?.purchaseOrderVehicleDetailId,
        ...(editedCostEntry ? { unitCost: editedCostEntry[1] } : {})
      } as ReceivePODetail;
    });
  } else {
    if (po.poType === 'ER' && !poType) poType = 'ER';
    const flatPODetails = generateFlatReceivedDetails(po.purchaseOrderDetails);
    console.log(flatPODetails, "flatPODetails item")
    console.log(flatPODetails, "flatPODetails item")
    receivedDetails = flatPODetails
      ?.filter(
        (item) =>
          (item?.quantityOrdered !== item?.receivedCount &&
            !item?.purchaseOrderDetailReceivedId) ||
          (item?.purchaseOrderDetailReceivedId && item?.partialReasonId)
      )
      .map((item) => {
        console.log(item.manufacturerSerialNumber, item, "itemss")
        console.log(item.manufacturerSerialNumber, item, "itemss")
        const isPartialItem = item.partialReasonId;
        const partialReceiveReason = isPartialItem
          ? item.receivedLineItemDetails?.[0].receivedReason || ''
          : '';
        const comments = isPartialItem
          ? item.receivedLineItemDetails?.[0].receivedComments || ''
          : '';
        return {
          purchaseOrderDetailId: item.purchaseOrderDetailId || '',
          purchaseOrderDetailReceivedId:
            item.purchaseOrderDetailReceivedId || '',
          condition: 'NEW',
          partial: isPartialItem ? 'true' : 'false',
          partialReceiveReason,
          dateReceived,
          billOfLading: enableMXPOReceivingValue == "1" ? bol : item.billOfLading || '',
          manufacturerSerialNumber: item.manufacturerSerialNumber || '',
          comments,
          purchaseOrderVehicleDetailId: item?.purchaseOrderVehicleDetailId
        } as ReceivePODetail;


      });
    console.log(receivedDetails, "receivedDetails")
  }

  const receivePO: ReceivePO = {
    purchaseOrderId: po.purchaseOrderId,
    storeNumber: getSelectedStore(),
    receivedDetails,
    poType: poType,
  };
  console.log(receivePO, "receivePOO")
  console.log(receivePO, "receivePOO")
  return receivePO;
};

export const isReceivePODetailsValid = (
  receivePODetails: ReceivePODetail[],
  isRequestForMaualPO: boolean,
  bol: string,
  enableMXPOReceivingValue : string | undefined
) => {

  if (!receivePODetails || !receivePODetails.length)
    return {
      isValid: false,
      message: `${t('Receive purchaseorder details are required.')}`,
    };
  console.log(bol, "boll")
  const inValidFields: string[] = [];
  receivePODetails.forEach((item) => {
  if (
    (!item.billOfLading && 
    !isRequestForMaualPO && 
    !inValidFields.includes('BOL')) || 
    (enableMXPOReceivingValue == "1" && 
    !bol && 
    !isRequestForMaualPO && 
    !inValidFields.includes('BOL'))
  ) {
    inValidFields.push('BOL');
  }
    if (!item.manufacturerSerialNumber && !inValidFields.includes('Serial #'))
      inValidFields.push('Serial #');
  });
  if (inValidFields.length) {
    if (inValidFields.length === 1) {
      return {
        isValid: false,
        message: `${inValidFields[0]} ${t('is required')}`,
      };
    } else {
      return {
        isValid: false,
        message: `${t('Serial # and BOL are required')}`,
      };
    }
  }

  return {
    isValid: true,
    message: '',
  };
};

const toOrdinal = (n: number): string => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

export const ReceivingPOFooter = ({
  onPrint,
  isPrintDisabled,
}: ReceivingPOFooter) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    selectedPO: { data: selectedPOToReceive, updatedPO, editedItemCosts },
    previouslyReceived: {
      data: purchaseOrders,
      selectedItemId: selectedPO,
      updatedPO: itemList,
    },
  } = useGlobalContext();

  const { setReloadData } = useSearchActions();
  const { manualPOReceive, queryParamsProp } = useSearchDetails();
  const [isRevDisable, setIsRevDisable] = useState(true);
  const [isReceiveDisable, setIsReceiveDisable] = useState(true);
  const [isReceiving, setIsReceiving] = useState(false);
  const [progressMessage, setProgressMessage] = useState('');
  const [showTryAgainReceiveModal, setShowTryAgainReceiveModal] =
    useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showConfirmRev, setShowConfirmRev] = useState(false);
  const [message, setMessage] = useState('');
  const [apiHasError, setApiHasError] = useState(false);
  const [hasValidationError, setHasValidationError] = useState(false);
  const [receiveByNumber, setReceiveByNumber] = useState(false);
  const [enableMPOonWeb, setEnableMPOonWeb] = useState(false);
  const { t } = useTranslation()

  // const { store } = useStoreDetails();
  const { bol, enableMXPOReceivingValue, oracleFusionEnableValue, localSourceRampValue } = useSearchDetails();
  
  console.log("oracleFusionEnableValue:", oracleFusionEnableValue)
  // const storeCountry: string | undefined = store?.countryAbb

  useEffect(() => {
    if (selectedPOToReceive?.purchaseOrderId) {
      setIsReceiveDisable(false);
    } else {
      setIsReceiveDisable(true);
    }
  }, [selectedPOToReceive]);

  useEffect(() => {
    if (selectedPO && itemList?.length > 0) {
      console.log("itemListitemList", itemList)
      itemList.forEach((one) => {
        if (one?.reversible) {
          setIsRevDisable(false);
        }
      });
    } else {
      setIsRevDisable(true);
    }
  }, [selectedPO, itemList]);

  useEffect(() => {
    const isReceiveByNumber = location?.search.includes('ponumber');
    if (isReceiveByNumber) {
      setReceiveByNumber(isReceiveByNumber);
    }
    const isMPOonWeb = location?.search.includes('enableMPOonWeb');
    if (isMPOonWeb) {
      setEnableMPOonWeb(isMPOonWeb);
    }
  }, []);

  const showAlertModal = (message: string) => {
    setShowAlert(true);
    setMessage(message);
  };

  const hideAlertModal = () => {
    setHasValidationError(false);
    setShowAlert(false);
    setMessage('');
  };

  const handleOkClick = () => {
    !apiHasError && !hasValidationError && setReloadData(true);
    hideAlertModal();
    if (queryParamsProp.origin == 'TB') {
      history.push({
        pathname: `/agreement/info/details/${queryParamsProp.customerId}/${queryParamsProp.agreementId}`,
      });
    }
  };

  const handleReceiveError = () => {
    if (manualPOReceive) {
      // If redirected from manual po receive
      setShowTryAgainReceiveModal(true);
    } else {
      showAlertModal(t(PO_RECEIVED_ERROR));
    }
    setApiHasError(true);
  };

  const handleReceiveClick = () => {

    const receivePOWithPOType = buildReceivePORequest(
      selectedPOToReceive,
      updatedPO,
      bol,
      enableMXPOReceivingValue,
      editedItemCosts
    );
    const { poType, ...receivePO } = receivePOWithPOType;
    const isRequestForMaualPO = poType === 'ER';
    console.log(receivePO.receivedDetails, "receivedDetailss", isRequestForMaualPO, "isRequestForMaualPO")
    const { isValid, message } = isReceivePODetailsValid(
      receivePO.receivedDetails,
      isRequestForMaualPO,
      bol,
      enableMXPOReceivingValue
    );
    if (!isValid) {
      setHasValidationError(true);
      showAlertModal(message);
      return;
    }

    // Cost sum validation for local source MPO
    const isLocalSourceMPO =
      localSourceRampValue === '1' &&
      isRequestForMaualPO &&
      !!selectedPOToReceive?.spendLimitId;
    if (isLocalSourceMPO) {
      const totalPOCost = parseFloat(selectedPOToReceive.totalCost || '0');
      let sumOfUnitCosts = 0;
      selectedPOToReceive.purchaseOrderDetails?.forEach((detail) => {
        const qty = Number(detail.quantityOrdered ?? 0);
        const detailId = detail.purchaseOrderDetailId;
        // Find edited cost for this detail if any key matches its detailId
        const editedEntry = editedItemCosts
          ? Object.entries(editedItemCosts).find(([key]) =>
              key.includes(`-${detailId}-`)
            )
          : undefined;
        const unitCost = editedEntry
          ? parseFloat(editedEntry[1]) || 0
          : parseFloat(String(detail.itemCost)) || 0;
        sumOfUnitCosts += unitCost * qty;
      });
      if (Math.abs(sumOfUnitCosts - totalPOCost) > 0.01) {
        setHasValidationError(true);
        showAlertModal(
          t('Sum of unit costs must equal the Total Cost of the PO')
        );
        return;
      }
    }

    const receivePOPayload: ReceivePORequest = {
      purchaseOrderReceive: [receivePO],
      ...(enableMPOonWeb ? { enableMPOonWeb: enableMPOonWeb } : {}),
      ...(oracleFusionEnableValue ? { isOracleFusionEnabled : oracleFusionEnableValue == '1' ? true : false } : {}),
    };
    const updateStoreActionItemPayload: StoreActionItemRequest = {
      storeActionItemIds: [queryParamsProp?.storeActionItemId],
      storeNumber: getSelectedStore(),
    };

    setIsReceiveDisable(true);
    setIsReceiving(true);
    setApiHasError(false);
    let alertModal = t(PO_RECEIVED_SUCCESS);

    // Split into per-item receives for local-source MPO with multiple items:
    // full-batch BE call can exceed the APIGW 30s cap; per-item calls stay under it.
    const shouldSplitReceive =
      isLocalSourceMPO && receivePO.receivedDetails.length > 1;

    if (shouldSplitReceive) {
      const modelByDetailId = new Map<string, string>();
      selectedPOToReceive?.purchaseOrderDetails?.forEach((d) => {
        if (d.modelNumber)
          modelByDetailId.set(d.purchaseOrderDetailId, d.modelNumber);
      });

      const runSplitReceive = async () => {
        const selectedItems = receivePO.receivedDetails;
        let successCount = 0;
        let anySpoCancelled = false;
        const failedModels: string[] = [];

        for (let i = 0; i < selectedItems.length; i++) {
          const n = toOrdinal(i + 1);
          const base = t('Receiving {{n}} item, please wait...', { n });
          const suffix =
            failedModels.length > 0
              ? '\n' +
                t('{{count}} item(s) failed so far', {
                  count: failedModels.length,
                })
              : '';
          setProgressMessage(base + suffix);
          const singlePayload: ReceivePORequest = {
            ...receivePOPayload,
            purchaseOrderReceive: [
              { ...receivePO, receivedDetails: [selectedItems[i]] },
            ],
          };
          try {
            const response: ReceivePOResponse[] = await receivePurchaseOrder(
              singlePayload
            );
            if (
              response[0]?.receivedDetails?.some(
                (d) => d.isSpecialOrderPOCancelled === 'true'
              )
            ) {
              anySpoCancelled = true;
            }
            successCount++;
          } catch (err: any) {
            // 504 = APIGW gave up but BE may have completed; treat as optimistic success.
            if (err?.response?.status === 504) {
              successCount++;
              continue;
            }
            const model =
              modelByDetailId.get(selectedItems[i].purchaseOrderDetailId) || n;
            failedModels.push(model);
          }
        }

        if (successCount === 0) {
          handleReceiveError();
          return;
        }

        if (anySpoCancelled) alertModal = t(SPO_AGREEMENT_CANCELLED);

        if (
          queryParamsProp?.origin == 'TB' &&
          queryParamsProp.storeActionItemId
        ) {
          try {
            await updateStoreActionItem(updateStoreActionItemPayload);
          } catch {
            // PO items already received; action-item cleanup can retry later.
          }
        }

        if (failedModels.length > 0) {
          showAlertModal(
            t('Failed to receive item(s) {{items}}', {
              items: failedModels.join(', '),
              defaultValue:
                'Failed to receive item(s): {{items}}, Please try again.',
            })
          );
          return;
        }
        showAlertModal(alertModal);
      };

      runSplitReceive().finally(() => {
        setIsReceiveDisable(false);
        setIsReceiving(false);
        setProgressMessage('');
      });
      return;
    }

    receivePurchaseOrder(receivePOPayload)
      .then((response: ReceivePOResponse[]) => {
        if (
          response[0].receivedDetails?.length >= 1 &&
          response[0].receivedDetails.some(
            (detail) => detail.isSpecialOrderPOCancelled === 'true'
          )
        ) {
          alertModal = t(SPO_AGREEMENT_CANCELLED);
        }
        if (
          queryParamsProp?.origin == 'TB' &&
          queryParamsProp.storeActionItemId
        ) {
          return updateStoreActionItem(updateStoreActionItemPayload);
        }
      })
      .then((res: ManageStoreActionItemsResponse | null) => {
        showAlertModal(alertModal);
      })
      .catch(handleReceiveError)
      .finally(() => {
        setIsReceiveDisable(false);
        setIsReceiving(false);
      });
  };

  const handleRevConfirmClose = () => {
    setShowConfirmRev(false);
    setApiHasError(false);
  };
  const handleRevConfirmFinish = (sucessFlag: boolean) => {
    setShowConfirmRev(false);
    setApiHasError(false);
    if (!sucessFlag) {
      setApiHasError(true);
      showAlertModal(t(PO_REVERSE_ERROR));
      setReloadData(true);
    } else {
      showAlertModal(t(PO_REVERSED_SUCCESS));
    }
  };
  return (
    <div className={clsx(classes.footerRoot, classes.hideOnPrint)}>
      {isReceiving && <LoadingOverlay message={progressMessage} />}
      <RACCard className={classes.card}>
        <div className={clsx(classes.cardBody)}>
          <div className={clsx(classes.row)}>
            <div className={classes.leftButtonsContainer}>
              <AlertModal
                open={showAlert}
                message={message}
                onClose={hideAlertModal}
                onOkClick={handleOkClick}
              />
              <TryAgainReceivePOModal
                open={showTryAgainReceiveModal}
                message={t(PO_RECEIVED_ERROR_TRY_AGAIN)}
                onTryAgain={() => setShowTryAgainReceiveModal(false)}
                onGoBack={() => history.push(AppRoute.ManualPO)}
              />
              <ReverseConfirm
                open={showConfirmRev}
                handleClose={handleRevConfirmClose}
                handleCallFinish={handleRevConfirmFinish}
              />
              {receiveByNumber && queryParamsProp.origin === REDIRECT_ORIGIN.INVENTORY && queryParamsProp.inventoryId ? (
                <RACButton
                  variant="outlined"
                  color="secondary"
                  onClick={() =>
                    history.push(`/inventory/${queryParamsProp.inventoryId}/details`)
                  }
                >
                  {t('Cancel')}
                </RACButton>
              ) : (
                receiveByNumber && (
                <Link
                  style={{ color: 'inherit', textDecoration: 'unset' }}
                  to={{
                    pathname: AppRoute.ManualPO,
                  }}
                >
                  <RACButton variant="outlined" color="secondary">
                      {t('Cancel')}
                  </RACButton>
                </Link>
                )
              )}
            </div>
            <div className={classes.rightButtonsContainer}>
              <RACButton
                disabled={isReceiveDisable}
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="receivingPOFooterPrint"
                color="primary"
                onClick={handleReceiveClick}
              >
                {t('Receive')}
              </RACButton>
              <RACButton
                disabled={isRevDisable}
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="POreverse"
                color="primary"
                onClick={() => {
                  setShowConfirmRev(true);
                  // console.log('ok');
                }}
              >
                {t('Reverse')}
              </RACButton>
              <RACButton
                disabled={isPrintDisabled}
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="receivingPOFooterPrint"
                color="primary"
                startIcon={
                  <Icon>
                    <FontAwesomeIcon icon={faPrint} />
                  </Icon>
                }
                onClick={onPrint}
              >
                {t('Print')}
              </RACButton>
            </div>
          </div>
        </div>
      </RACCard>
    </div>
  );
};
